import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Minimum length for a new password (Supabase enforces at least 6 server-side). */
export const MIN_PASSWORD_LENGTH = 8;

/** Group validator: `password` and `confirmPassword` must hold the same value. */
export const passwordsMatchValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const password = group.get('password')?.value;
  const confirm = group.get('confirmPassword')?.value;
  return !confirm || password === confirm ? null : { passwordsMismatch: true };
};

export interface FieldError {
  key: string;
  arg?: number;
}

/** First validation error of a control once the user has left it, as a translation key. */
export function fieldError(control: AbstractControl | null): FieldError | null {
  if (!control || !control.touched || !control.errors) return null;
  const errors = control.errors;
  if (errors['required']) return { key: 'auth.field.required' };
  if (errors['email']) return { key: 'auth.field.invalidEmail' };
  if (errors['minlength']) return { key: 'auth.field.minLength', arg: errors['minlength'].requiredLength };
  return null;
}
